import React, { useEffect, useRef, useState } from "react";
import { toClass } from "./index";
import "./datagrid.css";
export function useAutoFocus() {
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            ref.current.focus();
        }
    });
    return ref;
}
function CellEditor(props) {
    var cell = props.cell, source = props.source;
    var _a = useState(function () { return source.getValueAt(cell); }), value = _a[0], setValue = _a[1];
    var ref = useAutoFocus();
    return React.createElement("input", { ref: ref, type: 'text', value: value, onKeyDown: function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                source.setValueAt(cell, value);
                props.stopEditing();
            }
        }, onChange: function (e) { return setValue(e.target.value); } });
}
function SelectedCell(props) {
    var cell = props.cell;
    // const ref = useRef(null)
    var ref = useAutoFocus();
    var _a = useState(false), editing = _a[0], set_editing = _a[1];
    var onKeyPress = function (e) {
        if (e.key === 'Enter' && !editing) {
            if (props.source.isEditableAt(props.cell)) {
                set_editing(true);
            }
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (props.cell.row > 0) {
                props.setSelected({ row: cell.row - 1, col: cell.col });
            }
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (props.cell.row < props.source.rowCount() - 1) {
                props.setSelected({ row: cell.row + 1, col: cell.col });
            }
        }
        if (e.key === 'ArrowLeft') {
            var n = props.source.columnNames().indexOf(props.cell.col);
            if (n > 0) {
                n = n - 1;
            }
            var col = props.source.columnNames()[n];
            props.setSelected({ row: cell.row, col: col });
        }
        if (e.key === 'ArrowRight') {
            var n = props.source.columnNames().indexOf(props.cell.col);
            if (n >= 0 && n < props.source.columnNames().length - 1) {
                n = n + 1;
            }
            var col = props.source.columnNames()[n];
            props.setSelected({ row: cell.row, col: col });
        }
    };
    useEffect(function () {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'auto', block: "nearest", inline: 'nearest' });
        }
    });
    var content = React.createElement("span", null, props.cellRenderer.renderCellView(props.cell, props.source.getValueAt(props.cell)));
    var clss = {
        selected: true,
        editing: editing,
    };
    if (editing) {
        var editor = props.cellRenderer.renderCellEditor(props.cell, props.source.getValueAt(props.cell), props.source, function () { return set_editing(false); });
        if (!editor)
            editor = React.createElement(CellEditor, { source: props.source, cell: props.cell, stopEditing: function () { return set_editing(false); } });
        content = editor;
    }
    return React.createElement("td", { ref: ref, className: toClass(clss), tabIndex: 0, onKeyDown: onKeyPress }, content);
}
function DataCell(props) {
    var set_selected = function () {
        props.setSelected(props.cell);
    };
    if (props.selected.col === props.cell.col && props.selected.row === props.cell.row) {
        return (React.createElement(SelectedCell, { source: props.source, cell: props.cell, selected: props.selected, setSelected: props.setSelected, cellRenderer: props.cellRenderer }));
    }
    else {
        return React.createElement("td", { onClick: set_selected }, props.cellRenderer.renderCellView(props.cell, props.source.getValueAt(props.cell)));
    }
}
function DataRow(props) {
    var names = props.source.columnNames();
    var cols = names.map(function (name, i) {
        return React.createElement(DataCell, { key: name, source: props.source, cell: { row: props.row, col: name }, selected: props.selected, setSelected: props.setSelected, cellRenderer: props.cellRenderer });
    });
    var cls = {
        selected: props.selected.row === props.row
    };
    return React.createElement("tr", { className: toClass(cls) },
        React.createElement("th", { className: 'row-header' }, props.row),
        cols);
}
function DataHeader(props) {
    var names = props.source.columnNames();
    return React.createElement("tr", null,
        React.createElement("th", { className: 'empty col-header' }, "\u00A0"),
        names.map(function (name, i) {
            return React.createElement("th", { key: i, className: 'col-header' }, name);
        }));
}
var StringCellRenderer = /** @class */ (function () {
    function StringCellRenderer() {
    }
    StringCellRenderer.prototype.renderCellEditor = function (cell, value, source, stopEditing) {
        return null;
    };
    StringCellRenderer.prototype.renderCellView = function (cell, value) {
        return value + "";
    };
    return StringCellRenderer;
}());
export function DataGrid(props) {
    var _a = useState({ row: 0, col: 'unknown' }), selected = _a[0], set_selected = _a[1];
    var cellRenderer = props.cellRenderer || new StringCellRenderer();
    var rows = [];
    for (var i = 0; i < props.source.rowCount(); i++) {
        rows.push(React.createElement(DataRow, { key: i, row: i, source: props.source, selected: selected, setSelected: set_selected, cellRenderer: cellRenderer }));
    }
    return React.createElement("table", null,
        React.createElement("thead", null,
            React.createElement(DataHeader, { source: props.source })),
        React.createElement("tbody", null, rows));
}
